<template>
  <div
    class="drop"
    :class="[getClasses, { 'has-error': hasError }]"
    @dragover.prevent="dragOver"
    @dragleave.prevent="dragLeave"
    @drop.prevent="drop($event)"
  >
    <input type="file" id="uploadmytextfile" @change="requestUploadFile" />
    <h1 v-if="wrongFile">{{ $t('shared.upload.dropOrChoose') }}</h1>
    <span v-if="!file.name && !isDragging && !wrongFile">
      {{ $t('shared.upload.clickOrDrag') }}
    </span>
    <h6 v-else> {{file.name}}</h6>
  </div>
</template>

<script>
export default {
  name: 'drop-down',
  props: {
    callback: {
      type: Function,
      default: () => {},
    },
    hasError: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      file: { name: null },
      isDragging: false,
      wrongFile: false,
    };
  },
  computed: {
    getClasses() {
      return { isDragging: this.isDragging };
    },
  },
  methods: {
    dragOver() {
      this.isDragging = true;
    },
    dragLeave() {
      this.isDragging = false;
    },
    drop(e) {
      const { files } = e.dataTransfer;
      this.process(files);
    },
    requestUploadFile(event) {
      this.process(event.target.files);
    },
    process(files) {
      this.wrongFile = false;
      // allows only 1 file
      if (files.length === 1) {
        [this.file] = files;
        this.callback(this.file);
        this.isDragging = false;
      } else {
        this.wrongFile = true;
        this.file = null;
        this.isDragging = false;
      }
    },
  },
};
</script>

<style scoped>
.drop {
  width: 100%;
  height: 100%;
  background-color: #eee;
  border: 2px dashed #999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  transition: background-color 0.2s ease-in-out;
  font-family: sans-serif;
}
.isDragging {
  background-color: #999;
  border-color: #fff;
}
input#uploadmytextfile {
  position: absolute;
  width: 100%;
  height: 100%;
  right: 0;
  z-index: 2;
  font-size: 100px; /* Aumenta tamanho do campo */
  opacity: 0;
  filter: alpha(opacity=0);
  cursor: pointer;
}
h6 {
  margin-bottom: 0;
}

.drop.has-error {
  border-color: #dc3545;
  background-color: #fff5f5;
}

.drop.has-error span, .drop.has-error h6 {
  color: #dc3545;
}
</style>
